import Component from '../colorz/Component';

export default class ValidationForm extends Component {
	onInit(el) {
		this.el = el;
		this.formIsValid = false;

		this.elSubmitBtn = this.el.querySelector('.js-submit-btn');
		this.elMailError = this.el.querySelector('.js-mail-error');
		this.elMailInput = this.el.querySelector('.js-mail-input');
		this.elPhoneError = this.el.querySelector('.js-phone-error');
		this.elPhoneInput = this.el.querySelector('.js-phone-input');
		this.elCheckboxCgv = this.el.querySelector('.js-checkbox-cgv'); // optional
		this.requiredFields = this.el.querySelectorAll('.input[required]');
		this.elForm = this.el.querySelector('.js-form');

		this.elFirstNameError = this.el.querySelector('.js-first-name-error');
		this.elLastNameError = this.el.querySelector('.js-last-name-error');
		this.elMailEmptyError = this.el.querySelector('.js-mail-empty-error');
		this.elMessageError = this.el.querySelector('.js-field-error');
		this.elReasonError = this.el.querySelector('.js-reason-error');
		this.elPasswordError = this.el.querySelector('.js-password-error');
		this.elCgvError = this.el.querySelector('.js-cgv-error'); // optional
	}

	onReady() {
		this.bindEvents();
	}

	bindEvents() {
		this.elSubmitBtn.addEventListener('click', (e) => {
			e.preventDefault();

			this.formIsValid = true;

			const formData = new FormData(this.elForm);

			const {first_name, last_name, email, message, reason} =
				window.contactStrings;

			for (const [key, value] of formData) {
				switch (key) {
					case `contact[${first_name}]`:
						value.length === 0
							? this.displayMessage(this.elFirstNameError)
							: this.removeMessage(this.elFirstNameError);
						break;
					case `contact[${last_name}]`:
						value.length === 0
							? this.displayMessage(this.elLastNameError)
							: this.removeMessage(this.elLastNameError);
						break;
					case `contact[email]`:
					case 'customer[email]':
						value.length === 0
							? this.displayMessage(this.elMailEmptyError)
							: this.removeMessage(this.elMailEmptyError);
						break;
					case `contact[${message}]`:
						value.length === 0
							? this.displayMessage(this.elMessageError)
							: this.removeMessage(this.elMessageError);
						break;
					case `contact[${reason}]`:
						value.length === 0
							? this.displayMessage(this.elReasonError)
							: this.removeMessage(this.elReasonError);
						break;
					case 'customer[password]':
						value.length === 0
							? this.displayMessage(this.elPasswordError)
							: this.removeMessage(this.elPasswordError);
						break;
					default:
				}
			}

			if (this.elCheckboxCgv) {
				this.elCheckboxCgv.checked
					? this.removeMessage(this.elCgvError)
					: this.displayMessage(this.elCgvError);
			}

			this.formIsValid && this.elForm.submit();
		});

		if (this.elMailInput) {
			this.elMailInput.addEventListener('input', () => {
				if (this.validateEmail(this.elMailInput.value)) {
					this.removeMessage(this.elMailError);
					this.elSubmitBtn.removeAttribute('disabled');
				} else {
					this.displayMessage(this.elMailError);
					this.elSubmitBtn.setAttribute('disabled', '');
				}
			});
		}

		if (this.elPhoneInput) {
			this.elPhoneInput.addEventListener('input', (e) => {
				if (
					this.validatePhone(this.elPhoneInput.value) ||
					e.target.value.length === 0
				) {
					this.removeMessage(this.elPhoneError);
					this.elSubmitBtn.removeAttribute('disabled');
				} else {
					this.displayMessage(this.elPhoneError);
					this.elSubmitBtn.setAttribute('disabled', '');
				}
			});
		}
	}

	displayMessage(msg) {
		this.formIsValid = false;
		msg.classList.remove('u-hidden');
		msg.classList.add('u-mt-10');
		msg.setAttribute('aria-live', 'assertive');
		msg.setAttribute('role', 'status');
	}

	removeMessage(msg) {
		msg.classList.add('u-hidden');
		msg.classList.remove('u-mt-10');
		msg.removeAttribute('aria-live');
		msg.removeAttribute('role');
	}

	validateEmail(email) {
		const re =
			/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	}

	validatePhone(phone) {
		const re = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g;
		return re.test(phone);
	}
}
